
import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { changeState, logout, mudarMensagens } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import NaoIniciada from './NaoIniciada';
import { DEBUG, decrypt, URL } from '../variables';
import AceiteRegras from './AceiteRegras';
import AvaliacaoAndamento from './AvaliacaoAndamento';
import Finalizada from './Finalizada';
import MeetingRoom from './Meet';
//

import { createGlobalStyle } from 'styled-components';
import { Modal, ProgressBar } from 'react-bootstrap';
import Chat from './Chat';
import SweetAlert from 'react-bootstrap-sweetalert';
import { ServerClock } from './serverClock';
import {
    ArrowsLeftRight, Camera, CornersOut, IdentificationCard,
    ScanSmiley, SignIn, UserCheck, Waveform
} from '@phosphor-icons/react';
import { CandidateLoader, CandidateValidationNotice } from './CandidateUi';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import axios from 'axios';
import { Buffer } from 'buffer';
let silence = () => {
    let ctx = new AudioContext(), oscillator = ctx.createOscillator();
    let dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}
const StyleQuestion = createGlobalStyle`
 *::selection {
    background-color: #f1c40f !important;
    color:black !important;
    font-weight:bold !important;
 }
`

class ProcessoUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            nao_iniciado: false,
            regras_processo: false,
            andamento: false,
            finalizada: false,
            loading_screen: true,
            finish: false,
            full_screen: false,
            need_face_validation: false,
            chat_show: false,
            message_access: '',
            loading_access: false,
            request_validation: {},
            show_warning_decline: false,
            show_warning_approved: false,
            show_btn_validation_timer: false,
            show_btn_validation: false,
            document_identity_approved: false,
            show_document_modal: false,
            document_photo: null,
            document_face_photo: null,
            document_id_photo: null,
            document_capture_step: 'face',
            document_validation_status: 'idle',
            document_validation_message: '',
            document_face_ready: false,
            document_capture_countdown: null,
            validation_request_type: null
        };
        this.documentVideoRef = React.createRef();
        this.documentCanvasRef = React.createRef();
        this.recordingVideoRef = React.createRef();
        this.recordingCanvasRef = React.createRef();
        this.evaluationRef = React.createRef();
        this.evaluationCaptureProvider = null;
        this.last_date = moment().format('YYYY-MM-DD HH:mm:ss');
        this.need_delete_validation = []

        this.serverClock = new ServerClock();
        this.recordingId = this.uuidv4();
        this.recordingActive = false;
        this.imageCaptureActive = false;
        this.stoppingCapture = false;
        this.videoData = [];
        this.screenData = [];
        this.screenRecorderStarted = false;
    }

    shouldCaptureCandidate(processo = this.props.processo) {
        return processo != null && processo.simulado == false && processo.is_interview == false &&
            (processo.type_fiscalization == 'all' || processo.type_fiscalization == 'image');
    }

    shouldRecordVideo(processo = this.props.processo) {
        return this.shouldCaptureCandidate(processo) && processo.type_fiscalization == 'all';
    }

    shouldCaptureImageOnly(processo = this.props.processo) {
        return this.shouldCaptureCandidate(processo) && processo.type_fiscalization == 'image';
    }

    isExamCaptureStageActive(state = this.state) {
        return state.regras_processo == true || state.andamento == true;
    }

    canCaptureBeforeExam(processo = this.props.processo) {
        if (!this.shouldRecordVideo(processo)) {
            return false;
        }
        const minutes = parseInt(processo.recording_start_before_minutes || 0, 10);
        if (!Number.isFinite(minutes) || minutes <= 0 || processo.inicio == null) {
            return false;
        }
        const secondsUntilStart = this.serverClock.secondsUntil(processo.inicio);
        return secondsUntilStart > 0 && secondsUntilStart <= minutes * 60;
    }

    shouldRunProctoringCapture(state = this.state, props = this.props) {
        const processo = props.processo;
        if (!this.shouldCaptureCandidate(processo) || state.finish == true || props.stream == null) {
            return false;
        }
        return this.isExamCaptureStageActive(state) || (state.nao_iniciado == true && this.canCaptureBeforeExam(processo));
    }

    syncRecordingPreview() {
        const video = this.recordingVideoRef.current;
        if (video != null && this.props.stream != null && video.srcObject !== this.props.stream) {
            video.srcObject = this.props.stream;
            video.play().catch(() => {});
        }
    }

    getRecorderOptions() {
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            .test(navigator.userAgent);
        return {
            camera: {
                mimeType: mobile ? 'video/webm' : 'video/webm;codecs=h264',
                audioBitsPerSecond: 4000,
                videoBitsPerSecond: 500,
                bitsPerSecond: 500
            },
            screen: {
                mimeType: mobile ? 'video/webm' : 'video/webm;codecs=h264',
                videoBitsPerSecond: 50000,
                bitsPerSecond: 50000
            }
        };
    }

    getCaptureInterval() {
        const timer = parseInt(this.props.processo?.save_timer || 30000, 10);
        return !Number.isFinite(timer) || timer < 30000 ? 30000 : timer;
    }

    startProctoringCapture() {
        if (!this.shouldRunProctoringCapture()) {
            return;
        }
        this.syncRecordingPreview();
        if (this.shouldRecordVideo() && this.recordingActive != true) {
            this.recordingActive = true;
            this.recordingId = this.uuidv4();
            this.videoData = [];
            this.screenData = [];
            this.init_media_recorder(this.recordingId);
            this.init_media_recorder_screen(this.recordingId);
            return;
        }
        if (this.shouldCaptureImageOnly() && this.imageCaptureActive != true) {
            this.imageCaptureActive = true;
            this.save_logs_and_wording(true);
        }
    }

    stopProctoringCapture() {
        this.stoppingCapture = this.recordingActive == true;
        this.imageCaptureActive = false;
        clearTimeout(this.timeout_stop_media);
        clearTimeout(this.timeout_stop_screen);
        clearTimeout(this.timeout_save_logs_and_wording);
        let requestedStop = false;
        if (this.mediaRecorder != null && this.mediaRecorder.state != 'inactive') {
            requestedStop = true;
            this.mediaRecorder.stop();
        }
        if (this.mediaRecorder_2 != null && this.mediaRecorder_2.state != 'inactive') {
            requestedStop = true;
            this.mediaRecorder_2.stop();
        }
        if (requestedStop == false) {
            this.recordingActive = false;
            this.stoppingCapture = false;
        }
    }

    updateProctoringCapture() {
        this.syncRecordingPreview();
        if (this.shouldRunProctoringCapture()) {
            this.startProctoringCapture();
        } else {
            this.stopProctoringCapture();
        }
    }

    init_media_recorder(id) {
        if (!this.shouldRecordVideo() || this.props.stream == null) {
            return;
        }
        const options = this.getRecorderOptions();
        this.mediaRecorder = new MediaRecorder(this.props.stream, options.camera);
        this.mediaRecorder.ondataavailable = (e) => {
            this.videoData.push(e.data);
        };
        const idStream = this.props.stream.id;
        this.mediaRecorder.onstop = () => {
            clearTimeout(this.timeout_stop_media);
            if (id == this.recordingId && (this.recordingActive == true || this.stoppingCapture == true) && this.unmount != true) {
                this.salvar_dados(idStream, id);
            }
        };
        this.mediaRecorder.start();
        this.timeout_stop_media = setTimeout(() => {
            if (this.mediaRecorder != null && this.mediaRecorder.state != 'inactive') {
                this.mediaRecorder.stop();
            }
        }, this.getCaptureInterval());
    }

    init_media_recorder_screen(id) {
        this.screenRecorderStarted = true;
        if (!this.shouldRecordVideo() || this.props.processo.screen_sharing != true || this.props.stream_screen == null) {
            this.mediaRecorder_2 = null;
            return;
        }
        const options = this.getRecorderOptions();
        this.mediaRecorder_2 = new MediaRecorder(this.props.stream_screen, options.screen);
        this.mediaRecorder_2.ondataavailable = (e) => {
            this.screenData.push(e.data);
        };
        this.mediaRecorder_2.onstop = () => {
            clearTimeout(this.timeout_stop_screen);
            if (id == this.recordingId && (this.recordingActive == true || this.stoppingCapture == true) && this.unmount != true) {
                this.salvar_screen(id);
            }
        };
        this.mediaRecorder_2.start();
        this.timeout_stop_screen = setTimeout(() => {
            if (this.mediaRecorder_2 != null && this.mediaRecorder_2.state != 'inactive') {
                this.mediaRecorder_2.stop();
            }
        }, this.getCaptureInterval());
    }

    getEvaluationCaptureData() {
        if (typeof this.evaluationCaptureProvider == 'function') {
            return this.evaluationCaptureProvider();
        }
        if (this.evaluationRef.current && typeof this.evaluationRef.current.getCaptureData == 'function') {
            return this.evaluationRef.current.getCaptureData();
        }
        return {
            time_text: '',
            tab: 0,
            respostas: {}
        };
    }

    appendAnswersToForm(form, captureData = this.getEvaluationCaptureData()) {
        let textos = [];
        let titulos = [];
        let redacao_ids = [];
        const redacoes = this.props.redacoes || [];
        for (let i = 0; i < redacoes.length; i++) {
            textos.push(redacoes[i].resultado.texto);
            titulos.push(redacoes[i].resultado.titulo);
            redacao_ids.push(redacoes[i].redacao.id);
        }
        for (let i = 0; i < redacao_ids.length; i++) {
            form.append('textos[]', textos[i]);
            form.append('titulos[]', titulos[i]);
            form.append('redacao_ids[]', redacao_ids[i]);
        }
        const respostas = captureData.respostas || {};
        if (Object.values(respostas).length > 0) {
            form.append('respostas', JSON.stringify(respostas));
        }
    }

    drawCurrentCandidateFrame() {
        const video = this.recordingVideoRef.current;
        const canvas = this.recordingCanvasRef.current;
        if (video == null || canvas == null || video.videoWidth == 0 || video.videoHeight == 0) {
            return null;
        }
        canvas.height = video.videoHeight;
        canvas.width = video.videoWidth;
        canvas.getContext('2d').drawImage(video, 0, 0);
        return canvas.toDataURL('image/jpeg', 0.15);
    }

    uploadImage(url, file) {
        if (url == undefined || file == null) {
            return;
        }
        const type = file.split(';')[0].split('/')[1];
        const buffer = Buffer.from(file.replace(/^data:image\/\w+;base64,/, ""), 'base64');
        axios.put(url, buffer, {
            headers: { "Content-Type": type }
        }).catch((e) => console.log(e));
    }

    handleCaptureResponse(resp) {
        if (resp.message == "Unauthenticated.") {
            localStorage.removeItem('token');
            this.props.logout();
            return false;
        }
        if (resp.status == false || resp.message == 'Server Error') {
            this.get_processo();
            return false;
        }
        if (resp.processo == null) {
            this.props.changeState({ processo: null, stream: null, stream_screen: null });
            return false;
        }
        let data_request = {};
        if (resp.request_user != null && resp.request_user.updated_at != this.props.request_user?.updated_at) {
            data_request = { request_user: resp.request_user };
        }
        if (resp.processo != null && this.props.processo != null &&
            (resp.processo.chat_type != this.props.processo.chat_type ||
                resp.processo.full_screen != this.props.processo.full_screen ||
                resp.processo.updated_at != this.props.processo.updated_at ||
                this.props.processo.fim != resp.processo.fim ||
                data_request.request_user != undefined)) {
            this.props.changeState({ processo: resp.processo, ...data_request });
            this.fim = resp.processo.fim;
        }
        return true;
    }

    save_logs_and_wording(timeoutSend = true) {
        if (!this.shouldCaptureImageOnly()) {
            return;
        }
        const file = this.drawCurrentCandidateFrame();
        if (file == null) {
            this.timeout_save_logs_and_wording = setTimeout(() => this.save_logs_and_wording(timeoutSend), this.getCaptureInterval());
            return;
        }
        let form = new FormData();
        form.append('processo_id', this.props.processo.id);
        this.appendAnswersToForm(form);

        fetch(`${URL}api/save_logs_and_wording?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = decrypt(await responseLog.json());
                if (this.handleCaptureResponse(resp) && timeoutSend == true) {
                    this.uploadImage(resp.url_image, file);
                    this.timeout_save_logs_and_wording = setTimeout(() => this.save_logs_and_wording(timeoutSend), this.getCaptureInterval());
                }
            } catch (err) {
                console.log(err);
                this.timeout_save_logs_and_wording = setTimeout(() => this.save_logs_and_wording(timeoutSend), this.getCaptureInterval());
            }
        }).catch((err) => {
            console.log(err);
            this.timeout_save_logs_and_wording = setTimeout(() => this.save_logs_and_wording(timeoutSend), this.getCaptureInterval());
        });
    }

    async salvar_screen(id) {
        if (this.unmount == true || (this.recordingActive != true && this.stoppingCapture != true) || this.recordingId != id) {
            return;
        }
        if (this.stoppingCapture != true) {
            this.init_media_recorder_screen(id);
        }
        let date_tz = (this.serverClock.nowMoment() || moment(this.props.tempo_atual)).format('YYYY-MM-DD_HH-mm-ss');
        let form = new FormData();
        form.append('processo_id', this.props.processo.id);
        form.append('date', date_tz);
        const screenBlob = new Blob(this.screenData, { type: "video/webm;codecs=h264" });
        this.screenData = [];

        fetch(`${URL}api/salvar_screen?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = decrypt(await responseLog.json());
                if (this.handleCaptureResponse(resp) && resp.url_screen != undefined) {
                    axios.put(resp.url_screen, screenBlob, {
                        headers: { "Content-Type": screenBlob.type }
                    }).catch((e) => console.log(e));
                }
            } catch (err) {
                console.log(err);
            }
        }).catch((err) => console.log(err));
    }

    async salvar_dados(idStream, id) {
        if (this.unmount == true || (this.recordingActive != true && this.stoppingCapture != true) || this.recordingId != id) {
            return;
        }
        const values = this.props.getValues ? this.props.getValues() : {};
        const captureData = this.getEvaluationCaptureData();
        if (this.stoppingCapture != true) {
            this.init_media_recorder(id);
        }
        const file = this.drawCurrentCandidateFrame();
        if (file == null) {
            if (this.stoppingCapture == true) {
                this.recordingActive = false;
                this.stoppingCapture = false;
            }
            return;
        }
        let date_tz = (this.serverClock.nowMoment() || moment(this.props.tempo_atual)).format('YYYY-MM-DD_HH-mm-ss');
        let form = new FormData();
        this.appendAnswersToForm(form, captureData);
        form.append('tempo', captureData.time_text || '');
        form.append('tab', captureData.tab || 0);
        form.append('processo_id', this.props.processo.id);
        form.append('profile', 'jpeg');
        form.append('date', date_tz);
        form.append('scroll_position', window.scrollY);
        form.append('width_window', window.innerWidth);
        form.append('height_window', window.innerHeight);
        form.append('video', 'video');
        form.append('center_count', values.center_count || 0);
        form.append('down_count', values.down_count || 0);
        form.append('face_count', values.face_count || 0);
        form.append('frame_count', values.frame_count || 0);
        form.append('left_count', values.left_count || 0);
        form.append('right_count', values.right_count || 0);
        form.append('up_count', values.up_count || 0);
        form.append('multiface_count', values.multiface_count || 0);
        form.append('middle_count', values.middle_count || 0);
        const recordedBlob = new Blob(this.videoData, { type: "video/webm;codecs=h264" });
        this.videoData = [];

        fetch(`${URL}api/salvar_dados?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = decrypt(await responseLog.json());
                if (this.handleCaptureResponse(resp)) {
                    if (resp.url_video != undefined) {
                        axios.put(resp.url_video, recordedBlob, {
                            headers: { "Content-Type": recordedBlob.type }
                        }).catch((e) => console.log(e));
                    }
                    this.uploadImage(resp.url_image, file);
                }
                if (this.stoppingCapture == true) {
                    this.recordingActive = false;
                    this.stoppingCapture = false;
                }
            } catch (err) {
                console.log(err);
            }
        }).catch((err) => console.log(err));
    }

    biometricValidationComplete() {
        return this.props.processo?.face_validation != true || (
            this.props.face_detected == true &&
            this.props.left_movement == true &&
            this.props.center_movement == true &&
            this.props.right_movement == true &&
            this.props.audio_detected == true
        );
    }

    shouldRequireValidation(processo, documentApproved, requestValidation) {
        if (processo == null || this.validation == true) {
            return false;
        }
        if (processo.show_document == true && documentApproved != true) {
            return true;
        }
        if (requestValidation?.validation_type == 'movement' && requestValidation?.approved == true) {
            return false;
        }
        return processo.face_validation == true && !this.biometricValidationComplete();
    }

    normalizeRequestValidation(requestValidation, documentApproved) {
        if (documentApproved == true && requestValidation?.validation_type == 'document_identity') {
            return {};
        }
        return requestValidation != null ? requestValidation : {};
    }

    openDocumentValidation() {
        if (this.props.stream == null || this.props.stream.getVideoTracks().length == 0) {
            this.setState({
                document_validation_status: 'rejected',
                document_validation_message: 'A câmera ainda não está disponível. Confirme as permissões e tente novamente.'
            });
            return;
        }

        // Reuse the camera stream already published to the fiscal. Cloning or
        // constraining its source here can interrupt the active WebRTC track.
        this.setState({
            show_document_modal: true,
            document_photo: null,
            document_face_photo: null,
            document_id_photo: null,
            document_capture_step: 'face',
            document_validation_status: 'idle',
            document_validation_message: '',
            document_face_ready: false,
            document_capture_countdown: null
        }, () => {
            if (this.documentVideoRef.current != null) {
                const video = this.documentVideoRef.current;
                if (video.srcObject !== this.props.stream) {
                    video.srcObject = this.props.stream;
                }
                video.play().catch(() => {});
            }
        });
    }

    loadImageForCanvas(src) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = reject;
            image.src = src;
        });
    }

    async buildDocumentValidationPhoto(facePhoto, idPhoto) {
        const t = getLanguageTexts(getSelectedLanguage());
        if (facePhoto == null || idPhoto == null) {
            return null;
        }

        const [faceImage, idImage] = await Promise.all([
            this.loadImageForCanvas(facePhoto),
            this.loadImageForCanvas(idPhoto)
        ]);
        const canvas = document.createElement('canvas');
        const width = 1200;
        const height = 760;
        const gap = 28;
        const padding = 36;
        const cardWidth = (width - padding * 2 - gap) / 2;
        const cardHeight = height - padding * 2 - 58;
        const ctx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        ctx.fillStyle = '#f8fafc';
        ctx.fillRect(0, 0, width, height);
        ctx.fillStyle = '#172033';
        ctx.font = '700 26px Arial';
        ctx.fillText(t.identity_validation, padding, 42);

        const drawContained = (image, x, y, w, h, label) => {
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(x, y, w, h);
            ctx.strokeStyle = '#dce4ef';
            ctx.lineWidth = 2;
            ctx.strokeRect(x, y, w, h);
            const scale = Math.min(w / image.width, h / image.height);
            const drawWidth = image.width * scale;
            const drawHeight = image.height * scale;
            const drawX = x + (w - drawWidth) / 2;
            const drawY = y + (h - drawHeight) / 2;
            ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
            ctx.fillStyle = '#2563eb';
            ctx.font = '700 18px Arial';
            ctx.fillText(label, x + 18, y + 28);
        };

        drawContained(faceImage, padding, 70, cardWidth, cardHeight, t.candidate_face);
        drawContained(idImage, padding + cardWidth + gap, 70, cardWidth, cardHeight, t.document);
        return canvas.toDataURL('image/jpeg', 0.9);
    }

    async captureDocumentPhoto() {
        const t = getLanguageTexts(getSelectedLanguage());
        const video = this.documentVideoRef.current;
        if (video == null || video.videoWidth == 0) {
            this.setState({
                document_validation_status: 'rejected',
                document_validation_message: t.camera_preparing_image
            });
            return;
        }

        const canvas = this.documentCanvasRef.current;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        const photo = canvas.toDataURL('image/jpeg', 0.92);
        const data = {
            document_validation_status: 'captured',
            document_validation_message: this.state.document_capture_step == 'face'
                ? t.face_photo_captured_next_document
                : t.document_photo_captured_review,
            document_capture_countdown: null
        };

        if (this.state.document_capture_step == 'face') {
            data.document_face_photo = photo;
            data.document_capture_step = 'document';
        } else {
            data.document_id_photo = photo;
            const combinedPhoto = await this.buildDocumentValidationPhoto(this.state.document_face_photo, photo);
            data.document_photo = combinedPhoto;
        }
        this.setState(data);
    }

    retakeDocumentPhoto(type = 'all') {
        const data = {
            document_validation_status: 'idle',
            document_validation_message: '',
            document_face_ready: false,
            document_capture_countdown: null
        };
        if (type == 'face') {
            data.document_face_photo = null;
            data.document_photo = null;
            data.document_capture_step = 'face';
        } else if (type == 'document') {
            data.document_id_photo = null;
            data.document_photo = null;
            data.document_capture_step = 'document';
        } else {
            data.document_photo = null;
            data.document_face_photo = null;
            data.document_id_photo = null;
            data.document_capture_step = 'face';
        }
        this.setState(data);
    }

    closeDocumentValidation() {
        if (this.documentVideoRef.current != null) {
            this.documentVideoRef.current.srcObject = null;
        }
        // The stream belongs to the evaluation/WebRTC session and must remain active.
        this.setState({ show_document_modal: false });
    }

    continueAfterDocumentApproval() {
        if (this.props.processo.face_validation == true) {
            this.props.changeStateParent({
                audio_detected: false,
                face_detected: false,
                left_movement: false,
                center_movement: false,
                right_movement: false
            });
            this.validation = false;
            this.setState({
                need_face_validation: true,
                show_btn_validation: false,
                show_warning_approved: false,
                show_warning_decline: false
            });
            clearTimeout(this.timeout_btn_validation);
            this.timeout_btn_validation = setTimeout(() => this.show_btn_routine(), 25000);
            return;
        }

        this.setState({ need_face_validation: false });
    }

    getBaseCandidateStage(state = this.state) {
        if (state.finish == true) {
            return 'finished';
        }
        if (state.andamento == true) {
            return 'evaluation';
        }
        if (state.regras_processo == true) {
            return 'rules';
        }
        return 'waiting';
    }

    isIdentityValidationVisible(state = this.state, props = this.props) {
        return this.getIdentityValidationStage(state, props) != null;
    }

    getIdentityValidationStage(state = this.state, props = this.props) {
        const needsDocumentValidation = props.processo.show_document == true && state.document_identity_approved != true;
        const pendingDocumentValidation = state.document_identity_approved != true &&
            state.request_validation?.approved == null &&
            state.request_validation?.validation_type == 'document_identity';
        const pendingBiometricValidation = state.request_validation?.approved == null &&
            state.request_validation?.validation_type == 'movement';

        if (state.show_document_modal == true ||
            needsDocumentValidation == true ||
            pendingDocumentValidation == true ||
            state.document_validation_status == 'validating' ||
            (state.loading_access == true && state.validation_request_type == 'document_identity')) {
            return 'document_validation';
        }

        if (state.need_face_validation == true ||
            pendingBiometricValidation == true ||
            state.loading_access == true) {
            return 'face_validation';
        }

        return null;
    }

    syncCandidateStage(state = this.state, props = this.props) {
        const nextStage = this.getIdentityValidationStage(state, props) || this.getBaseCandidateStage(state);

        if (props.candidate_stage != nextStage) {
            this.props.changeState({ candidate_stage: nextStage });
        }
    }

    async validateDocumentIdentity() {
        if (this.state.document_face_photo == null || this.state.document_id_photo == null) {
            this.setState({
                document_validation_status: 'rejected',
                document_validation_message: 'Tire a foto do rosto e do documento antes de enviar.'
            });
            return;
        }

        let validationPhoto = this.state.document_photo;
        if (validationPhoto == null) {
            validationPhoto = await this.buildDocumentValidationPhoto(this.state.document_face_photo, this.state.document_id_photo);
        }

        this.setState({
            document_photo: validationPhoto,
            document_validation_status: 'validating',
            document_validation_message: ''
        });
        this.props.changeState({ candidate_stage: 'document_validation' });

        fetch(`${URL}api/validate_document_identity?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                processo_id: this.props.processo.id,
                user_name: this.props.user.name,
                photo: validationPhoto,
                face_photo: this.state.document_face_photo,
                document_photo: this.state.document_id_photo
            })
        }).then(async (response) => {
            const resp = decrypt(await response.json());
            if (resp.recognized === true || resp.verified === true) {
                if (this.documentVideoRef.current != null) {
                    this.documentVideoRef.current.srcObject = null;
                }
                this.setState({
                    show_document_modal: false,
                    document_identity_approved: true,
                    document_validation_status: 'approved',
                    document_validation_message: getLanguageTexts(getSelectedLanguage()).document_validated,
                    need_face_validation: this.props.processo.face_validation == true
                }, () => this.continueAfterDocumentApproval());
                return;
            }

            if (this.documentVideoRef.current != null) {
                this.documentVideoRef.current.srcObject = null;
            }
            const automaticValidationMessage = getLanguageTexts(getSelectedLanguage()).automatic_validation_not_configured;
            const responseMessage = resp.message || '';
            const documentValidationMessage = /valida[cç][aã]o autom[aá]tica n[aã]o est[aá] configurada/i.test(responseMessage)
                ? automaticValidationMessage
                : (responseMessage || automaticValidationMessage);
            this.setState({
                show_document_modal: false,
                request_validation: resp.request_validation || this.state.request_validation,
                document_validation_status: 'review_required',
                document_validation_message: documentValidationMessage
            });
            this.props.changeState({ candidate_stage: 'document_validation' });
        }).catch(() => {
            this.setState({
                document_validation_status: 'rejected',
                document_validation_message: getLanguageTexts(getSelectedLanguage()).capture_send_error
            });
        });
    }


    exitHandler(e) {
        // console.log(e)
        if (document.webkitIsFullScreen === false) {
            ///fire your event
            this.setState({ full_screen: false });
            this.event_fullscreen('exit_fullscreen');
        }
        else if (document.mozFullScreen === false) {
            ///fire your event
            this.setState({ full_screen: false });
            this.event_fullscreen('exit_fullscreen');
        }
        else if (document.msFullscreenElement === false) {
            ///fire your event
            this.setState({ full_screen: false });
            this.event_fullscreen('exit_fullscreen');
        }
        else if (document.fullscreenElement) {
            this.setState({ full_screen: true });

        }
    }

    openFullscreen(elem) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen().then(() => {
                this.setState({ full_screen: true });
            });

        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen().then(() => {
                this.setState({ full_screen: true });
            });

        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen().then(() => {
                this.setState({ full_screen: true });
            });

        }
        else {
            this.setState({ full_screen: true });
        }
        this.clicked = false;
    }

    solicitar_camera(rules) {
        // this.setState({ loading_camera: true, msg: '', show_solicitar: false });
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => this.get_camera(rules, stream)).catch(this.handleError.bind(this));
    }

    async get_camera(rules, stream_) {
        stream_.getTracks().map((track) => track.stop());

        var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        let device_local_mic = localStorage.getItem("deviceIdMic")

        console.log(devices);
        let exists = false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []
        let exists_mic = false;

        for (let i = 0; i < devices.length; i++) {
            if (devices[i].kind == 'videoinput') {
                if (!devices_cam_id.includes(devices[i].deviceId)) {
                    devices_camera.push(devices[i]);
                    devices_cam_id.push(devices[i].deviceId);

                }
                if (device_local == devices[i].deviceId) {
                    exists = true;
                }
            }
            else if (devices[i].kind == 'audioinput') {
                if (!devices_mic_id.includes(devices[i].deviceId)) {
                    devices_mic.push(devices[i]);
                    devices_mic_id.push(devices[i].deviceId);

                }
                if (device_local_mic == devices[i].deviceId) {
                    exists_mic = true;
                }
            }

        }
        console.log(devices_camera);
        console.log('oi');
        if (devices_camera.length > 0 && devices_mic.length > 0) {
            let use = '';
            let use_mic = ''

            if (exists == true) {
                use = device_local;
            }
            else {
                localStorage.setItem("deviceId", devices_camera[0]?.deviceId);
                use = devices_camera[0]?.deviceId;
            }

            if (exists_mic == true) {
                use_mic = device_local_mic;
            }
            else {
                localStorage.setItem("deviceIdMic", devices_mic[0]?.deviceId);
                use_mic = devices_mic[0]?.deviceId;
            }
            console.log(use)
            this.props.changeState({ devices_camera: devices_camera, devices_mic, device_select: use, device_select_mic: use_mic })
            navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: { exact: use }, frameRate: 4,
                    facingMode: "user",
                    width: 320,
                    height: 240
                }, audio: { deviceId: { exact: use_mic } }
            }).
                then((str) => this.handleSuccess(str, rules)).catch(this.handleError.bind(this));
        }
        else {
            this.setState({ show_solicitar: true, loading_camera: false, msg: 'Não foi reconhecido nenhuma câmera ou microfone conectado em seu computador. Conecte e tente novamente' })
        }
    }

    request_screen_sharing(stream, rules) {
        let extended = DEBUG ? false : window?.screen?.isExtended;
        if (extended == true) {
            if (stream) {
                stream.getTracks().map((track) => track.stop());
            }
            this.props.history.push({
                pathname: '/',
                search: '?error=Para compartilhar a tela você deve estar com apenas um monitor'
            });
        }
        else {
            navigator.mediaDevices
                .getDisplayMedia({
                    audio: false, video: {
                        frameRate: 24,
                        displaySurface: "monitor",
                        height: 500
                    }
                }
                )
                .then((strm) => {
                    if (this.unmount == true) {
                        strm.getTracks().map((track) => track.stop());
                        return;
                    }
                    let displaySurface = strm.getVideoTracks()[0].getSettings().displaySurface;
                    if (displaySurface !== 'monitor') {
                        strm.getTracks().map((track) => track.stop());
                        // this.setState({ loading_camera: false, msg: 'Compartilhe a tela cheia', show_screen_sharing: true });
                        this.request_screen_sharing(stream);
                        this.salvar_log_permission('Compartilhou a opção errada de tela: ' + displaySurface);

                    }
                    else {
                        let track = silence();
                        strm.addTrack(track)
                        this.props.changeState({ stream, stream_screen: strm });
                        this.salvar_log_permission('Aceitou permissão de compartilhamento de tela');

                        if (rules == true) {
                            this.aceitar_regras(this.resp);
                            this.get_time_server();
                        }

                    }
                })
                .catch((err) => {
                    if (stream) {
                        stream.getTracks().map((track) => track.stop());
                    }
                    try {
                        this.salvar_log_permission('Recusou permissão de compartilhamento de tela: ' + err);
                    }
                    catch (e) {

                    }
                    this.props.history.push({
                        pathname: '/',
                        search: '?error=Compartilhamento Tela foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
                    });
                    // this.setState({ loading_camera: false, msg: 'Compartilhe a tela cheia para avançar', show_screen_sharing: true });
                    console.error(err)
                });
        }

    }

    handleSuccess(stream, rules) {
        stream.oninactive = () => {
            try {
                this.salvar_log_permission('Cancelou permissão de câmera');
            }
            catch (e) {

            }
            this.props.history.push({
                pathname: '/',
                search: this.props.processo.screen_sharing == true ? '?error=Compartilhamento de Vídeo/Áudio ou Tela foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação' : '?error=Compartilhamento de Vídeo/Áudio foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
            });
        }
        // this.get_processo();
        this.salvar_log_permission('Aceitou permissão de câmera');

        if (this.props.processo.screen_sharing == true && this.props.processo.type_fiscalization == 'all') {
            this.request_screen_sharing(stream, rules);
        }
        else {
            this.props.changeState({ stream });
            this.aceitar_regras(this.resp);
            this.get_time_server();
        }

        // screenshotButton.disabled = false;
        // window.location="/processos_user"

        // this.setState({ show_aceitar: true, loading_camera: false, show_video: true,stream:stream });
        // this.videoRef.current.style.display = 'flex';

        // this.videoRef.current.srcObject = stream;
        // this.videoRef.current.volume = 0;
    }

    handleError(stream) {
        console.log(stream);
        let msg = '';
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceIdMic");
        if (stream.toString().includes('Permission denied')) {
            msg = 'Você bloqueou seu acesso a camera. Para liberá-lo vá nas configurações de seu navegador.';
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = 'Aceita as permissões de acesso a câmera para poder avançar.';
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = 'Não foi possível acessar sua câmera. Conecte uma câmera, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = 'Não foi possível acessar seu microfone. Conecte um microfone, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = 'Não foram reconhecidos nenhuma câmera ou microfone conectados em seu computador. Conecte-os e tente novamente.';
        }
        else {
            msg = stream.toString();
        }
        this.salvar_log_permission(msg + ' ' + stream.toString());
        this.setState({ redirect: true });

    }

    componentDidMount() {
        this.clicked = false;
        this.exitHandlerEvent = this.exitHandler.bind(this);
        document.addEventListener('fullscreenchange', this.exitHandlerEvent, false);
        document.addEventListener('mozfullscreenchange', this.exitHandlerEvent, false);
        document.addEventListener('MSFullscreenChange', this.exitHandlerEvent, false);
        document.addEventListener('webkitfullscreenchange', this.exitHandlerEvent, false);
        this.unmount = false;
        this.listen_channels();
        this.get_processo();
        if (this.props.processo.face_validation == true) {
            this.salvar_log_permission('Precisa de validação facial', 'need_face_validation');

            if (this.props.processo.face_validation_periodicaly == true) {
                this.timeout_validation = setInterval(() => {
                    let time = this.props.processo.time_validation_periodicaly;
                    let data = this.props.getLastDetection();
                    console.log('teste de validação')
                    console.log(this.state.request_validation)
                    if (
                        data.last_audio_detected != null &&
                        data.last_face_recognize != null &&
                        this.state.andamento == true &&
                        this.props.processo.face_validation == true &&
                        this.props.processo.face_validation_periodicaly == true &&
                        this.state.need_face_validation == false &&
                        !(this.props.request_user?.started != null && this.props.request_user?.pause_end == null) &&
                        (Math.abs(moment().diff(data.last_audio_detected, 'seconds')) > time
                            || Math.abs(moment().diff(data.last_face_recognize, 'seconds')) > time)
                    ) {
                        console.log('precisa de validação')
                        this.props.changeStateParent({
                            audio_detected: false,
                            face_detected: false,
                            left_movement: false,
                            center_movement: false,
                            right_movement: false
                        });
                        this.setState({
                            need_face_validation: true,
                            loading_access: false,
                            request_validation: {},
                            validation_request_type: null,
                            show_warning_approved: false,
                            show_warning_decline: false
                        });
                        this.validation = false;
                        this.salvar_log_permission('Precisa de validação facial', 'need_face_validation_again');
                    }
                }, 10000)
            }
        }

        // if (this.props.stream == null && this.props.processo_resultado!=null && this.props.processo_resultado.status=='I') {
        //     this.setState({ loading_screen: true });

        //     this.solicitar_camera();
        // }
        // else {
        //     this.get_processo();
        // }
    }

    salvar_log_permission(msg, type = 'permission') {
        fetch(`${URL}api/salvar_log?v=a&screen=${type}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (type == 'need_face_validation' && this.validation != true && this.unmount != true && this.props.processo.simulado == false && this.props.processo.restrict_access == true) {
                        setTimeout(() => {
                            if (type == 'need_face_validation' && this.validation != true && this.unmount != true) {
                                this.salvar_log_permission(msg, type);
                            }
                        }, this.props.processo.save_timer_pre_exam)
                    }
                }
            } catch (err) {
                console.log(err);
                if (type == 'need_face_validation' && this.validation != true && this.unmount != true && this.props.processo.simulado == false && this.props.processo.restrict_access == true) {
                    setTimeout(() => {
                        if (type == 'need_face_validation' && this.validation != true && this.unmount != true) {
                            this.salvar_log_permission(msg, type);
                        }
                    }, this.props.processo.save_timer_pre_exam)
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (type == 'need_face_validation' && this.validation != true && this.unmount != true && this.props.processo.simulado == false && this.props.processo.restrict_access == true) {
                    setTimeout(() => {
                        if (type == 'need_face_validation' && this.validation != true && this.unmount != true) {
                            this.salvar_log_permission(msg, type);
                        }
                    }, this.props.processo.save_timer_pre_exam)
                }


            });
    }

    componentDidUpdate(props, state) {
        console.log(props.processo, this.props.processo);

        if (props.processo.updated_at != this.props.processo.updated_at && props.processo.screen_sharing == false && this.props.processo.screen_sharing == true && this.props.processo_resultado.status == 'I' && this.props.processo.type_fiscalization == 'all') {
            console.log(props.processo);
            console.log('entrou');
            // this.solicitar_camera(false);
            this.request_screen_sharing(this.props.stream, false);

        }

        if (this.props.socket != props.socket) {
            this.listen_channels();
        }

        if (this.state.need_face_validation != state.need_face_validation && this.state.need_face_validation == true &&
            this.props.processo.face_validation == true) {
            console.log('chamou timer')
            clearTimeout(this.timeout_btn_validation);
            this.timeout_btn_validation = setTimeout(() => this.show_btn_routine(), 25000);
        }

        if (
            this.state.need_face_validation != state.need_face_validation ||
            this.state.show_document_modal != state.show_document_modal ||
            this.state.document_identity_approved != state.document_identity_approved ||
            this.state.document_validation_status != state.document_validation_status ||
            this.state.loading_access != state.loading_access ||
            this.state.regras_processo != state.regras_processo ||
            this.state.andamento != state.andamento ||
            this.state.finish != state.finish ||
            this.state.request_validation?.id != state.request_validation?.id ||
            this.state.request_validation?.validation_type != state.request_validation?.validation_type ||
            this.state.request_validation?.approved != state.request_validation?.approved ||
            this.state.request_validation?.sent_to_fiscal != state.request_validation?.sent_to_fiscal
        ) {
            this.syncCandidateStage();
        }
        if (
            props.stream != this.props.stream ||
            props.stream_screen != this.props.stream_screen ||
            props.processo?.id != this.props.processo?.id ||
            props.processo?.updated_at != this.props.processo?.updated_at ||
            this.state.nao_iniciado != state.nao_iniciado ||
            this.state.regras_processo != state.regras_processo ||
            this.state.andamento != state.andamento ||
            this.state.finish != state.finish
        ) {
            this.updateProctoringCapture();
        }
    }
    //
    componentWillUnmount() {
        this.unmount = true;
        document.removeEventListener('fullscreenchange', this.exitHandlerEvent, false);
        document.removeEventListener('mozfullscreenchange', this.exitHandlerEvent, false);
        document.removeEventListener('MSFullscreenChange', this.exitHandlerEvent, false);
        document.removeEventListener('webkitfullscreenchange', this.exitHandlerEvent, false);
        clearTimeout(this.timeout_get_processo)
        clearTimeout(this.timeout_timeserver)
        clearTimeout(this.timer_timeout)
        clearTimeout(this.request_access_timeout)
        clearTimeout(this.timeout_btn_validation)
        clearInterval(this.timeout_request_delete)
        clearInterval(this.timeout_validation)
        this.stopProctoringCapture();
        if (this.documentVideoRef.current != null) {
            this.documentVideoRef.current.srcObject = null;
        }
        if (this.recordingVideoRef.current != null) {
            this.recordingVideoRef.current.srcObject = null;
        }
    }

    listen_channels() {
        if (this.listen != true && this.props.socket != null) {
            this.listen = true
            this.props.socket.off('request_validation');
            this.props.socket.on('request_validation', (resp) => {
                console.log('request_validation', resp)
                console.log(this.state.request_validation?.updated_at)
                if (resp.type == 'response_delete') {
                    clearInterval(this.timeout_request_delete);
                }
                else if (this.validation != true) {
                    if (this.state.request_validation?.updated_at == undefined ||
                        this.state.request_validation.updated_at < resp.request_validation.updated_at
                    ) {
                        if (resp.request_validation.approved == true && resp.request_validation.validation_type == 'document_identity') {
                            this.need_delete_validation = this.need_delete_validation.filter((item) => item != resp.request_validation?.id)
                            this.setState({
                                document_identity_approved: true,
                                document_validation_status: 'approved',
                                document_validation_message: getLanguageTexts(getSelectedLanguage()).document_approved_by_proctor,
                                request_validation: {},
                                validation_request_type: null,
                                loading_access: false,
                                message_access: '',
                                show_warning_decline: false,
                                need_face_validation: this.props.processo.face_validation == true
                            }, () => this.continueAfterDocumentApproval());
                        }
                        else if (resp.request_validation.approved == true) {
                            this.need_delete_validation = this.need_delete_validation.filter((item) => item != resp.request_validation?.id)
                            this.setState({ show_warning_decline: false, show_warning_approved: true, request_validation: resp.request_validation, validation_request_type: null, loading_access: false });
                        }
                        else if (resp.request_validation.approved == false) {
                            this.need_delete_validation = this.need_delete_validation.filter((item) => item != resp.request_validation?.id)
                            this.setState({
                                show_warning_decline: true,
                                show_warning_approved: false,
                                request_validation: resp.request_validation,
                                validation_request_type: null,
                                loading_access: false,
                                message: '',
                                document_validation_status: resp.request_validation.validation_type == 'document_identity' ? 'rejected' : this.state.document_validation_status,
                                document_validation_message: resp.request_validation.validation_type == 'document_identity'
                                    ? getLanguageTexts(getSelectedLanguage()).capture_denied_by_proctor
                                    : this.state.document_validation_message
                            });
                        }
                    }
                }
            })

        }

    }

    show_btn_routine() {
        if (this.validation != true && this.props.processo.simulado == false) {
            // if(this.props.loading_media==false){
            this.setState({ show_btn_validation: true });
            // }
            // else{
            //     this.timeout_btn_validation = setTimeout(()=>this.show_btn_routine(),20000);
            // }
        }
    }

    get_processo(flag = '') {
        if (flag == '') {
            flag = '?v=a&version=v2';
        }
        else {
            flag += '&v=a&version=v2'
        }
        if (this.props.processo != null && this.props.processo.is_interview && this.props.socket != null) {
            this.props.socket.emit('exit_call', { aluno_id: this.props.user.id, processo_id: this.props.processo.id, id: this.props.user.id })
        }

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/get_processo${flag}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == 'Server Error') {
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                    return;
                }
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;

                }
                if (resp.errors != null || resp.error != null || resp.message == 'Server Error') {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                }
                else {
                    this.resp = resp;
                    if (resp.processo != null && (resp.processo.type_fiscalization == 'all' || resp.processo.type_fiscalization == 'image') && this.props.stream == null && resp.processo_resultado != null && resp.processo_resultado.status == 'I') {
                        // this.setState({ loading_screen: true });

                        this.solicitar_camera(true);
                    }
                    else {
                        this.aceitar_regras(resp);
                    }


                }
            } catch (err) {
                // this.setState({ redirect: true });
                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            }

        })
            .catch((err) => {
                // this.setState({ redirect: true });

                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            });
    }
    goToRules(flag = '') {
        // this.get_time_server();
        this.get_processo(flag);

    }

    aceitar_regras(resp) {
        if (resp.not_processo == true) {
            this.props.changeState({ processo: null });
            return;
        }
        if (resp.not_in_time == true) {
            if (this.props.stream_screen != null) {
                try {
                    this.props.stream_screen.getVideoTracks()[0].onended = function () { }

                    this.props.stream_screen.getTracks().map((track) => track.stop())
                } catch (e) {

                }
            }
            if (this.props.stream != null) {
                try {
                    console.log('finalizado stream6')

                    this.props.stream.oninactive = function () { }
                    this.props.stream.getTracks().map((track) => track.stop())
                } catch (e) {

                }
            }
            this.props.changeState({ stream_screen: null, stream: null });
            this.props.history.push({
                pathname: '/',
                search: '?error=' + resp.message
            });
            return;
        }
        // this.props.mudarUser(resp.user);
        // this.props.mudarProcesso(resp.processo);
        // this.props.mudarSala(resp.sala);
        // this.props.mudarTempoAtual(resp.tempo_atual);
        // if (this.props.stream == null && resp.finish != true ) {
        //     this.solicitar_camera();
        //     return;
        // }
        let processo_resultado = {};
        if (resp.processo_resultado != null) {
            processo_resultado.processo_resultado = resp.processo_resultado;
        }
        if (resp.request_validation != null) {
            if (!this.need_delete_validation.includes(resp.request_validation?.id)) {
                this.need_delete_validation.push(resp.request_validation?.id)
            }
        }

        if (resp.nao_iniciado == true || resp.simulado == true) {
            if (resp.processo == null) {
                this.props.changeState({ user: resp.user, processo: null, ...processo_resultado });
            }
            else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
                this.props.changeState({ mensagens: resp.mensagens, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            }
            else {
                this.props.changeState({ mensagens: resp.mensagens, user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            }
            const documentApproved = resp.document_identity_approved == true;
            const requestValidation = this.normalizeRequestValidation(resp.request_validation, documentApproved);
            this.setState({
                request_validation: requestValidation,
                validation_request_type: requestValidation?.validation_type || null,
                document_identity_approved: documentApproved,
                document_validation_status: documentApproved ? 'approved' : (requestValidation?.validation_type == 'document_identity' ? (requestValidation?.sent_to_fiscal == true ? 'awaiting_fiscal' : 'review_required') : this.state.document_validation_status),
                need_face_validation: this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation),
                loading_screen: false, finish: false, nao_iniciado: true, regras_processo: false, andamento: false, finalizada: false
            });
            if (this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation)) {
                this.props.changeStateParent({ show_btn_change: true })
            }
        }
        else if (resp.regras_processo == true) {
            if (resp.processo == null) {
                this.props.changeState({ user: resp.user, processo: null, ...processo_resultado });
            }
            else {
                if (resp.processo.simulado == true && this.props.socket != null) {
                    this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, enter_now: true });
                }
                // else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
                this.props.changeState({ mensagens: resp.mensagens, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
                // }
            }
            // else {
            //     this.props.changeState({mensagens: resp.mensagens, user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            // }
            const documentApproved = resp.document_identity_approved == true;
            const requestValidation = this.normalizeRequestValidation(resp.request_validation, documentApproved);
            this.setState({
                request_validation: requestValidation,
                validation_request_type: requestValidation?.validation_type || null,
                document_identity_approved: documentApproved,
                document_validation_status: documentApproved ? 'approved' : (requestValidation?.validation_type == 'document_identity' ? (requestValidation?.sent_to_fiscal == true ? 'awaiting_fiscal' : 'review_required') : this.state.document_validation_status),
                need_face_validation: this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation),
                loading_screen: false, finish: false, nao_iniciado: false, regras_processo: true, andamento: false, finalizada: false
            });
            if (this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation)) {
                this.props.changeStateParent({ show_btn_change: true })
            }
        }
        else if (resp.andamento == true) {
            for (let i = 0; i < resp.redacoes.length; i++) {
                if (resp.redacoes[i].resultado.texto == '' || resp.redacoes[i].resultado.texto == null) {
                    resp.redacoes[i].resultado.texto = '';
                }
                if (resp.redacoes[i].resultado.titulo == null) {
                    resp.redacoes[i].resultado.titulo = '';
                }
                resp.redacoes[i].resultado.texto = "\t" + resp.redacoes[i].resultado.texto;
            }
            if (resp.processo == null) {
                this.props.changeState({ user: resp.user, processo: null, ...processo_resultado });
            }
            else {
                if (resp.processo.simulado == true && this.props.socket != null) {
                    this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, enter_now: true });
                }
                this.props.changeState({ request_user: resp.request_user, entrevistas: resp.entrevistas, mensagens: resp.mensagens, redacoes: resp.redacoes, questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            }

            // else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
            //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            // }
            // else {
            //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
            // }
            const documentApproved = resp.document_identity_approved == true;
            const requestValidation = this.normalizeRequestValidation(resp.request_validation, documentApproved);
            this.setState({
                request_validation: requestValidation,
                validation_request_type: requestValidation?.validation_type || null,
                document_identity_approved: documentApproved,
                document_validation_status: documentApproved ? 'approved' : (requestValidation?.validation_type == 'document_identity' ? (requestValidation?.sent_to_fiscal == true ? 'awaiting_fiscal' : 'review_required') : this.state.document_validation_status),
                need_face_validation: this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation),
                loading_screen: false, finish: false, nao_iniciado: false, regras_processo: false, andamento: true, finalizada: false
            });
            if (this.shouldRequireValidation(resp.processo || this.props.processo, documentApproved, requestValidation)) {
                this.props.changeStateParent({ show_btn_change: true })
            }
            // this.props.mudarRedacoes(resp.redacoes);
            // this.props.mudarProvas(resp.provas);
            // this.props.mudarCategorias(resp.categorias);
            // this.props.mudarMensagens(resp.mensagens);

        }
        else if (resp.finish == true) {
            if (resp.processo == null) {
                this.props.changeState({ user: resp.user, processo: null, ...processo_resultado, provas: resp.provas != null ? resp.provas : [] });
            }
            else {
                this.props.changeState({ user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado, provas: resp.provas != null ? resp.provas : [], redacoes: resp.redacoes });
            }
            // else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
            //     this.props.changeState({ user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado, provas: resp.provas != null ? resp.provas : [] });
            // }
            // else {
            //     this.props.changeState({ user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado, provas: resp.provas != null ? resp.provas : [] });
            // }
            this.setState({ loading_screen: false, finish: true, nao_iniciado: false, regras_processo: false, andamento: false, finalizada: false });
        }
        setTimeout(() => this.syncCandidateStage(), 0);
        if (resp.tempo_atual) {
            clearTimeout(this.timer_timeout);
            this.serverClock.sync(resp.tempo_atual);
            this.incTimer();
        }



    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    salvar_log_full_screen(event) {
        let event_m = '';
        if (event == 'exit_fullscreen') {
            event_m = 'exit_fullscreen';
            if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
                if (this.props.socket != null) {

                    this.props.socket.emit("send_warning_behavior", { processo_id: this.props.processo.id, msg: 'O candidato saiu da tela cheia', sala_id: this.props.sala.id, aluno_id: this.props.user.id, nome_chat: this.props.user.name, id_msg: this.uuidv4(), faculdade_id: this.props.faculdade.id, type: 'in' });
                }

            }
        }
        else if (event == 'enter_fullscreen') {
            event_m = 'enter_fullscreen';
            if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
                if (this.props.socket != null) {

                    this.props.socket.emit("send_warning_behavior", { processo_id: this.props.processo.id, msg: 'O candidato entrou em tela cheia', sala_id: this.props.sala.id, aluno_id: this.props.user.id, nome_chat: this.props.user.name, id_msg: this.uuidv4(), faculdade_id: this.props.faculdade.id, type: 'in' });
                }
            }
        }
        else return;


        fetch(`${URL}api/salvar_log?v=a&screen=${event_m}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }


    event_fullscreen(e) {
        if (this.state.andamento == true && this.state.loading_screen == false && this.props.processo != null && this.props.processo.full_screen == true && this.props.processo.simulado == false) {
            this.salvar_log_full_screen(e);
        }
    }

    request_validation(validationType = 'movement') {
        const pendingValidation = this.state.request_validation?.approved == null &&
            this.state.request_validation?.validation_type == validationType;
        const pendingSentToFiscal = validationType == 'document_identity'
            ? pendingValidation && this.state.request_validation?.sent_to_fiscal == true
            : pendingValidation;

        if (this.state.loading_access == true ||
            pendingSentToFiscal) {
            return;
        }

        this.setState({
            loading_access: true,
            validation_request_type: validationType,
            message_access: getLanguageTexts(getSelectedLanguage()).sending_release_request
        });

        const requestBody = {
            processo_id: this.props.processo.id,
            validation_type: validationType,
            reason: validationType == 'document_identity' ? 'document_identity' : 'movement'
        };

        fetch(`${URL}api/request_validation?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else if (resp.message == "Server Error") {
                    this.setState({
                        loading_access: false,
                        validation_request_type: null,
                        message_access: 'Não foi possível enviar o pedido. Tente novamente.'
                    });
                }
                else {
                    if (validationType == 'document_identity' && resp.document_identity_approved == true) {
                        this.setState({
                            document_identity_approved: true,
                            document_validation_status: 'approved',
                            document_validation_message: getLanguageTexts(getSelectedLanguage()).document_already_approved,
                            request_validation: {},
                            validation_request_type: null,
                            loading_access: false,
                            need_face_validation: this.props.processo.face_validation == true
                        }, () => this.continueAfterDocumentApproval());
                        return;
                    }
                    // this.setState({loa})
                    let data = {};
                    if (resp.request_validation != null && (this.state.request_validation?.updated_at == undefined ||
                        this.state.request_validation.updated_at < resp.request_validation.updated_at
                    )) {
                        data.request_validation = resp.request_validation;
                        if (!this.need_delete_validation.includes(resp.request_validation?.id)) {
                            this.need_delete_validation.push(resp.request_validation?.id)
                        }
                    }
                    this.setState({ message_access: getLanguageTexts(getSelectedLanguage()).waiting_for_proctor_decision, ...data });
                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading_access: false, validation_request_type: null });

            });
    }

    get_time_server() {

        fetch(`${URL}api/get_time_server?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else if (resp.message == "Server Error") {
                    this.timeout_timeserver = setTimeout(() => {
                        this.get_time_server();
                    }, 5000);
                }
                else {
                    if (resp.atual != null) {
                        this.serverClock.sync(resp.atual);
                        this.props.changeState({ tempo_atual: resp.atual });
                    }
                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);
                this.timeout_timeserver = setTimeout(() => {
                    this.get_time_server();
                }, 5000);
            });
    }

    send_message(texto) {
        let uid_msg = this.uuidv4();
        let msg = texto;
        if (msg != null && msg != '' && msg.replace(/ /g, '') != '' && this.props.socket != null && msg?.length < 1000) {
            this.props.socket.emit("send_msg_fiscal", { processo_id: this.props.processo.id, msg: msg, sala_id: this.props.sala.id, aluno_id: this.props.user.id, nome_chat: this.props.user.name, id_msg: uid_msg, faculdade_id: this.props.faculdade.id });
            // $(this).val('');
            // $('#body_msg').append(template_send.replace(/%MSG%/g,msg).replace(/%ID%/g,uid_msg));
            // $('#body_msg').scrollTop($('#body_msg')[0].scrollHeight);
            let mensagens = [...this.props.mensagens];
            mensagens.push({
                type_message: 'message', sender: { id: this.props.user.id, name: this.props.user.name, }, sender_id: this.props.user.id,
                receive_id: null, sala_id: this.props.sala.id, uuid: uid_msg, visto: undefined, message: msg
            });
            this.props.mudarMensagens(mensagens);

            return true;

        }
        return false;
    }

    calculateValue() {
        if (this.state.request_validation?.validation_type == 'movement' && this.state.request_validation?.approved == true) {
            return 100;
        }

        const requirements = [
            this.props.face_detected == true,
            this.props.left_movement == true && this.props.center_movement == true && this.props.right_movement == true,
            this.props.audio_detected == true
        ];
        return Math.round((requirements.filter(Boolean).length / requirements.length) * 100);
    }

    incTimer() {
    if (!this.serverClock.isReady()) {
        return;
    }

    let totalSecs = this.serverClock.secondsUntil(this.props.processo.inicio);

    let data = {};

    if (
        totalSecs <= this.props.processo.chat_time &&
        this.state.chat_show == false
    ) {
        data.chat_show = true;
    }

    if (
        totalSecs <= this.props.processo.request_time &&
        this.state.show_btn_validation_timer == false
    ) {
            data.show_btn_validation_timer = true;
    }
    else {
        if (
            totalSecs > 0 &&
            totalSecs % 30 === 0 &&
            this.state.show_btn_validation_timer == false
        ) {
            this.get_time_server();
        }
    }

    if (Object.keys(data).length !== 0) {
        this.setState(data);
    }

    this.updateProctoringCapture();

    if (totalSecs <= 0) {
        totalSecs = 0;
        this.iniciado = true;
    }
    else {
        this.timer_timeout = setTimeout(() => {
            this.incTimer();
        }, 1000);
    }
}

    renderTips() {
        const t = getLanguageTexts(getSelectedLanguage());
        if (this.props.processo.face_validation == true) {
            if (this.props.loading_media) {
                return <CandidateLoader compact title={t.analyzing_image_audio} description={t.stay_visible_camera} />;
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == false) {
                console.log('nenhum rosto');
                return <CandidateValidationNotice title={t.face_not_detected}>{t.adjust_camera_position}</CandidateValidationNotice>;
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == true) {
                return <CandidateValidationNotice title={t.multiple_faces_detected}>{t.stay_alone_frame}</CandidateValidationNotice>;
            }
            else if (this.props.center_movement == false) {
                return <CandidateValidationNotice title={t.center_face_title}>{t.center_face_hint}</CandidateValidationNotice>;
            }
            else if (this.props.right_movement == false) {
                return <CandidateValidationNotice title={t.turn_face_right_title}>{t.turn_face_hint}</CandidateValidationNotice>;
            }
            else if (this.props.left_movement == false) {
                return <CandidateValidationNotice title={t.turn_face_left_title}>{t.turn_face_hint}</CandidateValidationNotice>;
            }
            else if (this.props.audio_detected == false) {
                return <CandidateValidationNotice title={t.validate_microphone_title}>{t.validate_microphone_hint}</CandidateValidationNotice>;
            }
            else {
                return <CandidateValidationNotice tone="success" title={t.validation_completed_title}>{t.validation_completed_hint}</CandidateValidationNotice>;
            }
        }
        else {
            return '';
        }
    }

    access_exam() {
        this.validation = true;
        this.get_time_server()
        if (this.props.socket != null && this.need_delete_validation.length > 0) {
            this.props.socket.emit('request_validation_delete', { user_id: this.props.user.id, processo_id: this.props.processo.id, sala_id: this.props.sala.id, validation_type: 'movement' })
            this.timeout_request_delete = setInterval(() => {
                this.props.socket.emit('request_validation_delete', { user_id: this.props.user.id, processo_id: this.props.processo.id, sala_id: this.props.sala.id, validation_type: 'movement' })
            }, 15000);
        }
        this.salvar_log_permission('Validação facial', 'face_validated')
        this.props.changeStateParent({ show_btn_change: false })
        this.setState({ need_face_validation: false, show_warning_approved: false, show_btn_validation: false }, () => {
            if (this.clicked == false && this.props.processo.full_screen == true) {
                this.clicked = true;
                this.openFullscreen(document.body);
                this.event_fullscreen('enter_fullscreen');
            }
        });

    }


    render() {//
        const t = getLanguageTexts(getSelectedLanguage());
        const requiredExternalCamera = this.props.processo?.required_external_camera == true;
        const externalCameraBlocked = requiredExternalCamera && this.props.external_camera_connected != true && (this.state.nao_iniciado == true || this.state.regras_processo == true || this.state.andamento == true);
        const activeStep = this.state.finish ? 3 : this.state.andamento ? 2 : this.state.regras_processo ? 1 : 0;
        const needsDocumentValidation = this.props.processo.show_document == true && this.state.document_identity_approved != true;
        const pendingDocumentReview = this.state.document_identity_approved != true &&
            this.state.request_validation?.approved == null &&
            this.state.request_validation?.validation_type == 'document_identity' &&
            this.state.request_validation?.sent_to_fiscal == true;
        const documentCaptureRegistered = this.state.document_identity_approved != true &&
            this.state.request_validation?.approved == null &&
            this.state.request_validation?.validation_type == 'document_identity' &&
            this.state.request_validation?.sent_to_fiscal != true;
        const pendingBiometricReview = this.state.request_validation?.approved == null &&
            this.state.request_validation?.validation_type == 'movement';
        return (
            <div className="row candidate-exam-page" onClick={() => {
                document.body.style.userSelect = 'text';
            }} onCopy={(e) => {
                if (this.props.processo.enable_copy_paste != true) {
                    e.preventDefault();
                }
            }}
                onCut={(e) => e.preventDefault()}
                onDrop={(e) => e.preventDefault()}
                onChange={(e) => e.preventDefault()}

            >
                {this.props.user?.accessibility == true && this.props.user?.type_supervisor != 'none' && <StyleQuestion />}
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                <video ref={this.recordingVideoRef} muted autoPlay playsInline style={{ position: 'fixed', width: 1, height: 1, opacity: 0, pointerEvents: 'none' }}></video>
                <canvas ref={this.recordingCanvasRef} style={{ display: 'none' }}></canvas>

                <div className="col-12 candidate-exam-column">
                    <div className="card candidate-process-card"
                    style={this.state.andamento?{    margin: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0}:{}}
                    >
                        <div className="card-body candidate-process-body" id="card">
                            <div hidden id="total_secs"></div>

                            <div className="candidate-progress" aria-label={t.evaluation_steps}>
                                {[t.preparation_stage, t.rules_stage, t.evaluation_stage].map((label, index) => (
                                    <div key={label} className={`candidate-progress-step ${index < activeStep ? 'is-complete' : ''} ${index === activeStep ? 'is-active' : ''}`}>
                                        <span>{index < activeStep ? '✓' : index + 1}</span>
                                        <strong>{label}</strong>
                                    </div>
                                ))}
                            </div>

                            <h4 className="mt-0 header-title candidate-process-title" id='titulo_processo'>{this.props.processo.name}</h4>
                            <p className="candidate-name">{t.candidate}: <strong>{this.props.user.name}</strong></p>

                            {this.props.processo.type_time == 'all' && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.start_time}: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.end_time}: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}
                                </p>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto == null && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.process_start_time}: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.process_end_time}: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.started_at}: </b>
                                    -
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.finishes_at}: </b>
                                    -
                                </p>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto != null && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.process_start_time}: </b>
                                    {moment(this.props.processo.inicio_absoluto).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.process_end_time}: </b>
                                    {moment(this.props.processo.fim_absoluto).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.started_at}: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm:ss')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>{t.finishes_at}: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm:ss')}
                                </p>
                            </>}

                            <hr className="candidate-divider" />
                            {(this.state.regras_processo == true || this.state.andamento == true) && this.state.need_face_validation == false && externalCameraBlocked == false && <div hidden={this.props.show_call && (this.props.user.accessibility == false || this.props.user.type_supervisor == 'none' || this.props.processo.is_interview == true)} id='timer'
                                className={`timer_exam candidate-main-timer ${this.props.processo?.type_fiscalization == 'none' ? 'candidate-main-timer--no-preview' : 'candidate-main-timer--with-preview'}`}>

                            </div>}
                            {this.state.loading_screen == false && <div>
                                {this.state.need_face_validation == false ? <>
                                    <p className="m-b-20" style={{ color: 'black', whiteSpace: 'pre-line', fontSize: '1rem' }}><b style={{ fontWeight: 'bold' }}>{t.evaluation_description}: </b>
                                        {"\n"}
                                        {this.props.processo.descricao}
                                    </p>
                                    <div hidden={this.state.full_screen == false && this.props.processo.full_screen == true}>


                                        {externalCameraBlocked == true && <CandidateValidationNotice tone="warning" title={t.external_camera_required_title}>{t.external_camera_required_hint}</CandidateValidationNotice>}
                                        {externalCameraBlocked == false && this.state.nao_iniciado == true && <NaoIniciada send_message={(m) => this.send_message(m)} goToRules={this.goToRules.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                        {externalCameraBlocked == false && this.state.regras_processo == true && <AceiteRegras validation_photo={this.state.document_photo} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                    </div>
                                    <div>
                                        {this.state.finish == true && <Finalizada aceitar_regras={this.aceitar_regras.bind(this)} changeStateParent={(e) => this.props.changeStateParent(e)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                    </div>

                                    {this.props.show_call && <MeetingRoom
                                        student={this.props.user}
                                        full_screen={this.state.full_screen}
                                        getAdminId={() => this.props.user.id}
                                        send_message={(m) => this.send_message(m)}
                                        sala_id={this.props.sala?.id}
                                        faculdade_id={this.props.faculdade?.id}
                                        getServerTime={() => this.serverClock.nowMoment()}
                                        processo={this.props.processo} closeCall={() => {
                                            this.props.changeState({ show_call: false })
                                        }}
                                    // get_messages_from_student={(id) => this.props.mensagens}
                                    />}

                                    <div hidden={this.state.full_screen == true || this.state.finish == true || this.props.processo.full_screen == false}>
                                                <CandidateValidationNotice tone="info" title={t.return_fullscreen_title}>{t.return_fullscreen_hint}</CandidateValidationNotice>

                                        <div >
                                            <button onClick={() => {
                                                if (this.clicked == false) {
                                                    this.clicked = true;
                                                    this.openFullscreen(document.body);
                                                    this.event_fullscreen('enter_fullscreen');
                                                }

                                                // this.setState({ full_screen: true });

                                            }} type="button" id="aceitar" className="btn btn-success btn-lg waves-effect waves-light candidate-icon-button" style={{ width: '100%' }}><CornersOut size={22} weight="bold" /> {t.access_fullscreen_evaluation}</button>

                                        </div>
                                    </div>

                                </> : <div className="candidate-biometric-panel">
                                    <div className="candidate-permission-heading">
                                        <div>
                                            <span className="candidate-section-kicker">{t.identity_validation}</span>
                                            <h5>{needsDocumentValidation ? t.send_document_validation_title : t.confirm_face_movement_microphone}</h5>
                                        </div>
                                        <strong>{needsDocumentValidation ? (this.props.processo.face_validation == true ? '1/2' : '1/1') : `${this.calculateValue()}%`}</strong>
                                    </div>

                                    {needsDocumentValidation ? <>
                                        <div className="candidate-requirements">
                                            <p className="candidate-requirement-item is-pending">
                                                <IdentificationCard size={24} weight="bold" />
                                                <span>{t.readable_document_requirement}</span>
                                            </p>
                                        </div>
                                        <CandidateValidationNotice tone="info" title={t.confirm_document_first}>
                                            {t.document_validation_instruction}
                                        </CandidateValidationNotice>

                                        {!pendingDocumentReview && !documentCaptureRegistered && <button
                                            type="button"
                                            onClick={() => this.openDocumentValidation()}
                                            className="btn btn-primary btn-lg waves-effect waves-light candidate-icon-button"
                                            style={{ width: '100%', marginTop: 10 }}
                                        >
                                            <Camera size={22} weight="bold" /> {t.photograph_face_document}
                                        </button>}

                                        {(this.state.document_validation_status == 'review_required' || documentCaptureRegistered) && !pendingDocumentReview && <button
                                            type="button"
                                            disabled={this.props.connect == false || this.state.loading_access}
                                            onClick={() => this.request_validation('document_identity')}
                                            className="btn btn-outline-primary btn-lg waves-effect waves-light candidate-icon-button"
                                            style={{ width: '100%', marginTop: 10 }}
                                        >
                                            <UserCheck size={22} weight="bold" /> {t.request_proctor_review}
                                        </button>}

                                        {documentCaptureRegistered && <button
                                            type="button"
                                            onClick={() => this.openDocumentValidation()}
                                            className="btn btn-light btn-lg waves-effect waves-light candidate-icon-button"
                                            style={{ width: '100%', marginTop: 10 }}
                                        >
                                            <Camera size={22} weight="bold" /> {t.take_new_photos}
                                        </button>}

                                        {this.state.document_validation_message != '' && <CandidateValidationNotice
                                            tone={this.state.document_validation_status == 'rejected' ? 'warning' : 'info'}
                                            title={this.state.document_validation_status == 'review_required' ? t.manual_review_available : t.document_validation}
                                        >
                                            {this.state.document_validation_message}
                                        </CandidateValidationNotice>}
                                        {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.validation_connection_hint}</CandidateValidationNotice>}

                                        {(pendingDocumentReview || (this.state.loading_access && this.state.validation_request_type == 'document_identity')) && <CandidateLoader
                                            compact
                                            title={t.document_sent_to_proctor}
                                            description={t.document_sent_to_proctor_hint}
                                        />}
                                    </> : <>
                                        <div className="candidate-requirements">
                                            <p className={`candidate-requirement-item ${this.props.stream != null && this.props.face_detected == true ? 'is-complete' : 'is-pending'}`}>
                                                <ScanSmiley size={22} weight="bold" /><span>{t.face_detected}</span>
                                            </p>
                                            <p className={`candidate-requirement-item ${this.props.stream != null && this.props.left_movement == true && this.props.right_movement == true && this.props.center_movement == true ? 'is-complete' : 'is-pending'}`}>
                                                <ArrowsLeftRight size={22} weight="bold" /><span>{t.movements_confirmed}</span>
                                            </p>
                                            <p className={`candidate-requirement-item ${this.props.stream != null && this.props.audio_detected == true ? 'is-complete' : 'is-pending'}`}>
                                                <Waveform size={22} weight="bold" /><span>{t.microphone_validated}</span>
                                            </p>
                                        </div>
                                        <ProgressBar striped variant="info" animated label={`${this.calculateValue()}% ${t.completed}`} className="candidate-permission-progress" now={this.calculateValue()} max={100} />
                                        {this.renderTips()}
                                        {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.validation_connection_hint}</CandidateValidationNotice>}
                                        {this.props.processo.simulado == false && this.state.show_btn_validation_timer == true && this.state.show_btn_validation == true && !pendingBiometricReview && this.state.loading_access == false && this.calculateValue() != 100 && <button onClick={() => {
                                            if (this.props.connect == true) {
                                                this.request_validation('movement');
                                            }
                                        }} type="button" disabled={this.props.connect == false} className="btn btn-warning btn-lg waves-effect waves-light candidate-icon-button" style={{ width: '100%', marginTop: 10 }}><UserCheck size={22} weight="bold" /> {t.request_help_release_proctor}</button>}
                                        {this.props.processo.simulado == false && this.state.show_btn_validation != true && !pendingBiometricReview && this.state.loading_access == false && this.calculateValue() != 100 && <CandidateValidationNotice tone="info" title={t.validation_in_progress}>{t.validation_in_progress_hint}</CandidateValidationNotice>}
                                        {(pendingBiometricReview || (this.state.loading_access && this.state.validation_request_type == 'movement')) && this.calculateValue() != 100 && <CandidateLoader compact title={this.state.message_access || t.request_in_progress} description={t.wait_proctor_response} />}
                                        {this.calculateValue() == 100 && <button onClick={() => {
                                            this.access_exam();
                                        }} type="button" className="btn btn-success btn-lg waves-effect waves-light candidate-icon-button" style={{ width: '100%', marginTop: 10 }}><SignIn size={22} weight="bold" /> {t.access_evaluation}</button>}
                                    </>}

                                    {this.props.processo.simulado == false && this.state.chat_show == true && this.props.processo_resultado?.status != 'F' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <Chat
                                        send_message={(m) => this.send_message(m)}
                                    />}
                                    <SweetAlert
                                        success
                                        title={t.approved_title}
                                        onConfirm={() => {
                                            this.access_exam();
                                        }}
                                        // onCancel={this.onCancel.bind(this)}
                                        show={this.state.show_warning_approved}
                                        confirmBtnText={t.access_evaluation}
                                        cancelBtnText={t.cancel}
                                        confirmBtnBsStyle="info"
                                        // cancelBtnBsStyle="success"
                                        showCancel={false}
                                    >
                                        {/* Questão respondida com sucesso */}
                                        {t.release_request_approved}
                                    </SweetAlert>
                                    <SweetAlert
                                        danger
                                        title={t.denied_title}
                                        onConfirm={() => this.setState({ show_warning_decline: false })}
                                        // onCancel={this.onCancel.bind(this)}
                                        show={this.state.show_warning_decline}
                                        confirmBtnText={t.ok}
                                        cancelBtnText={t.cancel}
                                        confirmBtnBsStyle="info"
                                        // cancelBtnBsStyle="success"
                                        showCancel={false}
                                    >
                                        {t.release_request_denied_hint}
                                    </SweetAlert>


                                </div>}

                            <Modal
                                show={this.state.show_document_modal}
                                onHide={() => this.closeDocumentValidation()}
                                centered
                                size="lg"
                                dialogClassName="candidate-document-modal"
                            >
                                <Modal.Header >
                                    <div>
                                        <span className="candidate-section-kicker">{t.document_step}</span>
                                        <Modal.Title>{t.photograph_face_document_title}</Modal.Title>
                                    </div>
                                    <span onClick={() => {
                                this.setState({show_document_modal:false})
                            }} style={{fontSize:16}} className="close"></span>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="candidate-document-layout">
                                        <div className="candidate-document-preview">
                                            <video ref={this.documentVideoRef} muted autoPlay playsInline></video>
                                            <div className={`candidate-capture-mask is-${this.state.document_capture_step}`} aria-hidden="true">
                                                {this.state.document_capture_step == 'face'
                                                    ? <div className="candidate-face-mask"><span>{t.face}</span></div>
                                                    : <div className="candidate-id-mask"><span>{t.document}</span></div>}
                                            </div>
                                            <div className="candidate-auto-capture-status" role="status">
                                                {this.state.document_capture_step == 'face'
                                                    ? t.fit_face_capture
                                                    : t.fit_document_capture}
                                            </div>
                                            <div className="candidate-document-guide">
                                                <IdentificationCard size={22} weight="bold" />
                                                <span>{t.review_photo_before_send}</span>
                                            </div>
                                        </div>
                                        <div className="candidate-document-instructions">
                                            <div><i className="mdi mdi-lightbulb-on-outline"></i><span>{t.document_tip_light}</span></div>
                                            <div><i className="mdi mdi-account-card-details"></i><span>{t.document_tip_visible_data}</span></div>
                                            <div><i className="mdi mdi-shield-check-outline"></i><span>{t.document_tip_not_repeated}</span></div>
                                        </div>
                                    </div>
                                    <div className="candidate-document-review-grid">
                                        <div className={`candidate-document-review ${this.state.document_face_photo != null ? 'has-photo' : ''}`}>
                                            <span>{t.face_photo}</span>
                                            {this.state.document_face_photo != null
                                                ? <img src={this.state.document_face_photo} alt="Prévia do rosto" />
                                                : <div className="candidate-document-empty">{t.not_captured_yet}</div>}
                                            {this.state.document_face_photo != null && <button
                                                type="button"
                                                className="btn btn-link candidate-review-action"
                                                onClick={() => this.retakeDocumentPhoto('face')}
                                            >
                                                <i className="mdi mdi-refresh"></i> {t.retake_face}
                                            </button>}
                                        </div>
                                        <div className={`candidate-document-review ${this.state.document_id_photo != null ? 'has-photo' : ''}`}>
                                            <span>{t.document_photo}</span>
                                            {this.state.document_id_photo != null
                                                ? <img src={this.state.document_id_photo} alt="Prévia do documento" />
                                                : <div className="candidate-document-empty">{t.not_captured_yet}</div>}
                                            {this.state.document_id_photo != null && <button
                                                type="button"
                                                className="btn btn-link candidate-review-action"
                                                onClick={() => this.retakeDocumentPhoto('document')}
                                            >
                                                <i className="mdi mdi-refresh"></i> {t.retake_document}
                                            </button>}
                                        </div>
                                    </div>
                                    {this.state.document_validation_message != '' && <div className={`candidate-document-message is-${this.state.document_validation_status}`}>{this.state.document_validation_message}</div>}
                                    <canvas ref={this.documentCanvasRef} style={{ display: 'none' }}></canvas>
                                </Modal.Body>
                                <Modal.Footer>
                                    {(this.state.document_face_photo != null || this.state.document_id_photo != null) && <button
                                        type="button"
                                        className="btn btn-outline-secondary candidate-icon-button"
                                        onClick={() => this.retakeDocumentPhoto('all')}
                                    >
                                        <i className="mdi mdi-refresh"></i> {t.restart_photos}
                                    </button>}
                                    {(this.state.document_face_photo == null || this.state.document_id_photo == null) && <button
                                        type="button"
                                        className="btn btn-primary candidate-icon-button"
                                        onClick={() => this.captureDocumentPhoto()}
                                    >
                                        <Camera size={20} weight="bold" /> {this.state.document_capture_step == 'face' ? t.take_face_photo : t.take_document_photo}
                                    </button>}
                                    {this.state.document_face_photo != null && this.state.document_id_photo != null && <button
                                        type="button"
                                        disabled={this.state.document_validation_status == 'validating'}
                                        className="btn btn-primary candidate-icon-button"
                                        onClick={() => this.validateDocumentIdentity()}
                                    >
                                        <UserCheck size={20} weight="bold" /> {this.state.document_validation_status == 'validating' ? t.validating : t.send_to_validation}
                                    </button>}
                                </Modal.Footer>
                            </Modal>

                            </div>}

                            {this.state.loading_screen == true && <CandidateLoader title={t.preparing_evaluation} description={t.loading_rules_workbooks_settings} />}


                        </div>

                    </div>

                    {this.state.need_face_validation == false && this.state.andamento == true && externalCameraBlocked == false &&  <>
                                    <div hidden={this.state.full_screen == false && this.props.processo.full_screen == true}>
                                        {<AvaliacaoAndamento ref={this.evaluationRef} setEvaluationCaptureProvider={(provider) => { this.evaluationCaptureProvider = provider; }} changeStateParent={(e) => this.props.changeStateParent(e)} getValues={() => this.props.getValues()} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                    </div>
                                </>}
                </div>
            </div>
        );
    }
}
const mapsStateToProps = (state) => (
    {
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        token: state.AppReducer.token,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        processo_resultado: state.AppReducer.processo_resultado,
        // worker: state.AppReducer.worker,
        sala: state.AppReducer.sala,
        faculdade: state.AppReducer.faculdade,
        show_call: state.AppReducer.show_call,
        mensagens: state.AppReducer.mensagens,

        socket: state.AppReducer.socket,
        connect: state.AppReducer.connect,
        request_user: state.AppReducer.request_user,
        redacoes: state.AppReducer.redacoes,
        provas: state.AppReducer.provas,
        candidate_stage: state.AppReducer.candidate_stage,
        external_camera_connected: state.AppReducer.external_camera_connected,
        candidate_inside_screen: state.AppReducer.candidate_inside_screen,


    }
);

export default connect(mapsStateToProps, { changeState, logout, mudarMensagens })(ProcessoUser);
